import type { AdNode } from "../../../core/AdNode";
import {
  addSizeToAllResponsiveSizes,
  type SizeTuple,
} from "../../../helpers/slotSizes";
import { isMobile } from "../../../helpers/isMobile";
import { FAN_TAKEOVER_FLOOR_SIZES } from "./consts";

function updateSizes(
  adNode: AdNode,
  sizeToAdd: SizeTuple,
  sizeToRemove: SizeTuple,
) {
  // In order to fill our actual companion creative, we need to
  const sizes = addSizeToAllResponsiveSizes(adNode.getSizes(), sizeToAdd);
  adNode.setSizes(sizes);
  adNode.removeSizes(sizeToRemove);
}

export function updateSizesForCompanions(adNode: AdNode) {
  // In order to fill our actual companion creative, we need to
  // replace the 9x9 with a 11x11 on desktop and 6x6 with 8x8 on mobile
  // to light up the campaign creative that will render an ad
  if (isMobile()) {
    updateSizes(
      adNode,
      FAN_TAKEOVER_FLOOR_SIZES.MOBILE_SUCCESS,
      FAN_TAKEOVER_FLOOR_SIZES.MOBILE_COLLAPSE,
    );
  } else {
    updateSizes(
      adNode,
      FAN_TAKEOVER_FLOOR_SIZES.DESKTOP_SUCCESS,
      FAN_TAKEOVER_FLOOR_SIZES.DESKTOP_COLLAPSE,
    );
  }
}
